import { render, staticRenderFns } from "./UpgradeScreen.vue?vue&type=template&id=7d10e944&scoped=true&"
import script from "./UpgradeScreen.vue?vue&type=script&lang=ts&"
export * from "./UpgradeScreen.vue?vue&type=script&lang=ts&"
import style0 from "./UpgradeScreen.vue?vue&type=style&index=0&id=7d10e944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d10e944",
  null
  
)

export default component.exports